var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-dropdown__wrapper" }, [
    _c("div", { staticClass: "global-dropdown global-dropdown--native" }, [
      _c(
        "div",
        {
          staticClass: "global-dropdown__head",
          class: [_vm.iconClass, _vm.themeClass],
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.nativeSelection,
                  expression: "nativeSelection",
                },
              ],
              class: { disabled: _vm.disabled, "has-error": _vm.hasError },
              attrs: { disabled: _vm.disabled },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.nativeSelection = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "", disabled: "" } }, [
                _vm._v(_vm._s(_vm.initialTitle)),
              ]),
              _vm._v(" "),
              _vm._l(_vm.options, function (option, index) {
                return [
                  _c("option", {
                    key: index,
                    attrs: { disabled: option.disabled },
                    domProps: {
                      value: option,
                      innerHTML: _vm._s(_vm.nativeOptionTitle(option)),
                    },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "global-dropdown global-dropdown--styled",
        class: [_vm.isOpen ? "global-dropdown--open" : ""],
      },
      [
        _c("div", {
          staticClass: "global-dropdown__head",
          class: [
            _vm.disabled ? "disabled" : "",
            _vm.hasError ? "has-error" : "",
            _vm.iconClass,
            _vm.themeClass,
          ],
          domProps: { innerHTML: _vm._s(_vm.displayedTitle) },
          on: {
            click: function ($event) {
              return _vm.toggleFilter()
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen",
              },
            ],
            staticClass: "global-dropdown__body",
            class: _vm.themeClass,
          },
          [
            _c(
              "ul",
              { staticClass: "global-dropdown__list" },
              [
                _vm._l(_vm.options, function (option, index) {
                  return [
                    _c("li", {
                      key: index,
                      staticClass: "global-dropdown__option",
                      class: {
                        selected: _vm.isSelected(option),
                        disabled: option.disabled,
                        "global-dropdown__option--group":
                          option.style === "group",
                        "global-dropdown__option--nested":
                          option.style === "nested",
                      },
                      domProps: { innerHTML: _vm._s(option.title) },
                      on: {
                        click: function ($event) {
                          return _vm.handleOptionClick(option)
                        },
                      },
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }